import React from 'react';
import PropTypes from 'prop-types';
import { schoolClicked } from '../../../utils/events/schools';
import ImageText from '../ImageText';
import Link from '../../Link';
import styles from './styles.less';

const SchoolLink = ({ school, linkClassName, className, textClassName, ...props }) => {
  let { logo } = school;
  const urlFront = logo ? logo.substring(0, logo.lastIndexOf('.')) : '';
  const ext = logo ? logo.slice(logo.lastIndexOf('.'), logo.length) : '';
  logo = logo ? urlFront.concat('-small').concat(ext) : '';

  return (
    <span className={styles.linkImg} onClick={() => schoolClicked(school)}>
      <Link
        className={`link ${linkClassName} ${styles.schoolLink} school-link`}
        route="schoolShow"
        school={school.link}
        id={school.shortId}
        {...props}
      >
        <ImageText
          className={className}
          textClassName={textClassName}
          image={logo}
          text={school.title || school.Name}
        />
      </Link>
    </span>
  );
};

SchoolLink.propTypes = {
  school: PropTypes.object.isRequired,
  linkClassName: PropTypes.string,
  className: PropTypes.string,
  textClassName: PropTypes.string,
};

SchoolLink.defaultProps = {
  linkClassName: null,
  className: null,
  textClassName: '',
};

export default SchoolLink;
